<template>
    <div class="section">
        <ul class="video-lists-box">
            <li class="video-lists" v-for="v in videos" :key="v.id">
                <!--<router-link class="video-lists-link" :to="{name: 'video', params: {id: v.id, src: v.src}}" :title="v.title">-->
                <a class="video-lists-link" :href="`/videos/${v.id}`" target="_blank" :title="v.title">
                    <div class="pr">
                        <i class="icon-play"></i>
                        <img class="video-thumb" v-lazy="v.thumb">
                        <div class="video-thumb video-mask"></div>
                    </div>
                    <div class="video-meta-box">
                        <div class="video-title-box">
                            <h3 class="video-title ellipsis">{{v.title}}</h3>
                            <span class="video-cate ellipsis" :title="`舞蹈风格: ${v.cate}`">{{v.cate}}</span>
                        </div>
                        <p class="video-count-box">
                            <span class="video-plays" :title="`播放量: ${v.views}`">
                                <i class="icon-video"></i> {{$view(v.views)}}
                            </span>
                            <span class="video-comments" :title="`评论数: ${v.comments}`">
                                <i class="icon-clock"></i> {{$time(v.addtime)}}
                            </span>
                        </p>
                    </div>
                </a>
                <!--</router-link>-->
            </li>
        </ul>

        <el-pagination
                v-if="up.opus > 40 && !is_loading"
                background layout="total, prev, pager, next"
                :current-page="page"
                @current-change="nextPage"
                :page-size="40"
                :total="up.opus"
        ></el-pagination>
        <div v-show="!is_loading && !up.opus && !videos.length" class="empty">
            <i class="icon-empty"></i>
            空间主人还没有投过视频哦~
        </div>
        <div v-show="is_loading" class="empty">
            <div class="loading-big"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            up: Object,
        },
        data: () => ({
            videos: [],
            page: 1,
            counts: 0,
            is_loading: true,
            is_paging: false,
        }),
        methods: {
            async nextPage(page) {// 页码改变
                if (this.is_paging) return;
                this.is_paging = true;
                this.videos = await this.api.get(`users/${this.id}/opuses`, {page}).catch(this.err);
                window.scrollTo(0, 0);
                this.is_paging = false;
            },
        },
        computed: {
            id() {
                return +this.$route.params.id;
            },
            user() {
                return this.$store.state.user;
            },
            uid() {
                return this.user.id;
            },
        },
        async beforeMount() {
            this.videos = await this.api.get(`users/${this.id}/opuses`).catch(this.err);
            this.is_loading = false;
        }
    }
</script>

<style scoped>
    @import "../../../static/css/common/lists.css";
    @import "../../../static/css/views/home/lists.css";
    @import "../../../static/css/views/space/opus.css";
</style>


// WEBPACK FOOTER //
// src/views/space/Opus.vue